/* eslint-disable no-console,prefer-rest-params */
const Mockbar = {
    debug() {
        console.info("[ROLLBAR DEBUG]", arguments);
    },
    info() {
        console.info("[ROLLBAR INFO]", arguments);
    },
    warn() {
        console.warn("[ROLLBAR WARN]", arguments);
    },
    error() {
        console.error("[ROLLBAR ERROR]", arguments);
    },
};

export default window.Rollbar || Mockbar;
